module.exports = __webpack_public_path__ + "static/img/kaishihuiyi.b10048b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/kaishihuiyi.png
// module id = 4MFf
// module chunks = 24